import type { RouteObject } from 'react-router';

import { cmsFilesRouteObjects } from '#/modules/cms/files/routing/cmsFiles.route-objects';
import * as cmsRootHorizonRouteExports from '#/modules/cms/pages/root/CmsRoot.horizon-route';
import * as cmsSplatHorizonRouteExports from '#/modules/cms/pages/splat/CmsSplat.horizon-route';
import { cmsRootRoute, cmsSplatRoute } from '#/modules/cms/routing/cms.routes';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

export const cmsRouteObjects = [
  {
    path: cmsRootRoute.relativePath,
    ...horizonRouteToObject(cmsRootHorizonRouteExports),
  },
  {
    path: cmsSplatRoute.fullPath,
    ...horizonRouteToObject(cmsSplatHorizonRouteExports),
  },
  ...cmsFilesRouteObjects,
] satisfies RouteObject[];
